/* DeusDream · Perfumes por mayor (alineado con los packs de Kamura).
   - Diseñador: unidad (máx. 1 suelta) o pack x2 del mismo perfume → línea propia con _dd_wholesale_tier "02"
     y un _dd_wholesale_pack_id único. SMART Functions ("Descuento mayorista pack") aplica el % solo a esa línea.
   - Árabes y body splash: se agregan por unidad, sin límite (modo "mix"). Cuando el carrito suma 6 o más de la
     misma línea (pueden ser distintos), el carrito las marca con tier "m6a" / "m6b" y SMART aplica el descuento.
   - Antes de agregar un pack x2 se pide confirmación. */
(function () {
  'use strict';
  if (window.DDPerfumePacks) return;

  const LOOSE_LIMIT = 1;
  const TIER_VALUE = { 2: '02', 5: '05' };
  const root = () => {
    const r = window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/';
    return r.endsWith('/') ? r : r + '/';
  };
  const getCart = async () => {
    const res = await fetch(root() + 'cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' });
    if (!res.ok) throw new Error('No se pudo leer el carrito.');
    return res.json();
  };
  const notify = (source, cart) => {
    const promise = Promise.resolve({ cart: { totalQuantity: Number(cart.item_count) || 0 }, detail: { itemCount: Number(cart.item_count) || 0, items: cart.items || [] } });
    const ev = new Event('shopify:cart:lines-update', { bubbles: true });
    Object.defineProperties(ev, { action: { value: 'update' }, context: { value: 'product' }, lines: { value: [] }, promise: { value: promise } });
    (source || document).dispatchEvent(ev);
    document.querySelectorAll('[data-dd-mobile-cart-count]').forEach((el) => { el.textContent = cart.item_count; el.hidden = !cart.item_count; });
  };
  const token = (variantId, tier) => {
    const rnd = window.crypto && typeof window.crypto.randomUUID === 'function' ? window.crypto.randomUUID() : Math.random().toString(36).slice(2) + Date.now().toString(36);
    return variantId + '-p' + tier + '-' + rnd;
  };
  const isPackLine = (item) => { const p = item.properties || {}; return p._dd_wholesale_mode === 'pack' && !!p._dd_wholesale_tier; };

  /* ---------- Confirmación (igual que tecnología: "Vas a agregar N unidades del mismo producto") ---------- */
  let dialog;
  const confirmPack = (info) => new Promise((resolve) => {
    if (!dialog) {
      dialog = document.createElement('div');
      dialog.className = 'dd-pfconfirm';
      dialog.setAttribute('role', 'dialog');
      dialog.setAttribute('aria-modal', 'true');
      dialog.setAttribute('aria-labelledby', 'dd-pfconfirm-title');
      dialog.hidden = true;
      document.body.appendChild(dialog);
    }
    dialog.innerHTML =
      '<div class="dd-pfconfirm__card">' +
        '<div class="dd-pfconfirm__bottles" aria-hidden="true">' + '<i></i>'.repeat(Math.min(info.tier, 5)) + '</div>' +
        '<p class="dd-pfconfirm__eyebrow">Confirmá tu pack</p>' +
        '<h2 id="dd-pfconfirm-title">Pack x' + info.tier + ' · −' + info.pct + '%</h2>' +
        '<p>Vas a agregar <b>' + info.tier + ' unidades del mismo perfume</b>: ' + info.title + '.</p>' +
        '<div class="dd-pfconfirm__sum"><span>' + info.each + ' c/u</span><strong>Total ' + info.total + '</strong></div>' +
        '<p class="dd-pfconfirm__rule">El descuento es solo para este pack del mismo perfume. No se combina con otras fragancias ni se acumula.</p>' +
        '<div class="dd-pfconfirm__actions"><button type="button" class="is-primary" data-ok>Agregar pack x' + info.tier + '</button><button type="button" data-cancel>Cancelar</button></div>' +
      '</div>';
    dialog.hidden = false;
    const done = (v) => { dialog.hidden = true; document.removeEventListener('keydown', onKey); resolve(v); };
    const onKey = (e) => { if (e.key === 'Escape') done(false); };
    document.addEventListener('keydown', onKey);
    dialog.onclick = (e) => {
      if (e.target === dialog || e.target.closest('[data-cancel]')) done(false);
      else if (e.target.closest('[data-ok]')) done(true);
    };
    const ok = dialog.querySelector('[data-ok]');
    if (ok) ok.focus();
  });

  /* ---------- Agregar ---------- */
  const add = async (opts) => {
    const variantId = Number(opts.variantId);
    const tier = Number(opts.tier) || 1;
    const count = Math.max(1, Number(opts.count) || 1);
    if (!variantId) throw new Error('Producto no disponible.');

    if (tier > 1 && opts.confirm !== false) {
      const ok = await confirmPack({ tier: tier, pct: opts.pct, title: opts.title || 'este perfume', each: opts.each || '', total: opts.total || '' });
      if (!ok) return null;
    }

    let items;
    const line = opts.line || 'disenador';
    if (line === 'arabe' || line === 'body') {
      const qty = Math.max(1, Number(opts.qty) || 1);
      items = [{ id: variantId, quantity: qty, properties: { _dd_perfume: 'true', _dd_wholesale: 'true', _dd_wholesale_mode: 'mix', _dd_pf_line: line } }];
    } else if (tier === 1) {
      const cart = await getCart();
      const loose = (cart.items || []).reduce((s, i) => (Number(i.variant_id) === variantId && !isPackLine(i) ? s + (Number(i.quantity) || 0) : s), 0);
      if (loose + 1 > LOOSE_LIMIT) throw new Error('Ya tenés 1 unidad suelta de este perfume. Para 2 o más, elegí el pack x2 y recibí el descuento.');
      items = [{ id: variantId, quantity: 1, properties: { _dd_perfume: 'true', _dd_wholesale: 'true', _dd_wholesale_mode: 'assorted', _dd_pf_line: 'disenador' } }];
    } else {
      items = [];
      for (let k = 0; k < count; k += 1) {
        items.push({ id: variantId, quantity: tier, properties: { _dd_perfume: 'true', _dd_wholesale: 'true', _dd_wholesale_mode: 'pack', _dd_wholesale_tier: TIER_VALUE[tier], _dd_wholesale_pack_id: token(variantId, tier), _dd_pf_line: 'disenador' } });
      }
    }

    const res = await fetch(root() + 'cart/add.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    });
    const data = await res.json();
    if (!res.ok) throw new Error(data.description || data.message || 'No se pudo agregar al carrito.');
    const cart = await getCart();
    notify(opts.source, cart);
    return cart;
  };

  window.DDPerfumePacks = { add: add, confirm: confirmPack, LOOSE_LIMIT: LOOSE_LIMIT, TIER_VALUE: TIER_VALUE };
})();
